import { debounce } from 'es-toolkit/compat';
import $ from 'jquery';

(function initialize() {
  var refreshForm = function refreshForm(e) {
    var $form = $(this).closest('form');
      var attributes = $form.data('refresh') || {};
      var $spinnerTarget = attributes.spinner_target ? $(attributes.spinner_target) : $form;
      var url = attributes.path || $form.attr('action');

    if ($(e.target).data('initial-value') === e.target.value) {
      return;
    }

    // check if the tab key (keycode 9) was used to get to an empty field
    if (e.type === 'keyup' && e.target.value === '' && e.which === 9) {
      return;
    }

    if (e.type === 'keyup' && e.target.type === 'text' && (e.which >= 37 && e.which <= 40)) {
      return;
    }

    if (e.type === 'change' && e.target.type === 'text' && !$(e.target).hasClass('datepicker')) {
      return;
    }

    // masked inputs emit a change event when the value is formatted, causing a refresh loop
    if (e.isTrigger && $(e.target).data('mask')) {
      return;
    }

    $spinnerTarget.showSpinner();
    $(e.target).blur();

    $form.data('pendingRequest', $.ajax({
      url,
      method: attributes.method || 'GET',
      data: $form.serialize(),
      dataType: 'script',
      beforeSend() {
        if ($form.data('pendingRequest')) {
          $form.data('pendingRequest').abort();
        }
      }
    }).always(function refreshFormAlways(xhr, textStatus) {
      var $refreshedInput = $(`#${  e.target.id}`);
      if ($refreshedInput.is('[type=text], textarea')) {
        var {length} = $refreshedInput.val();
        $refreshedInput.focus().get(0).setSelectionRange(length, length);
      }
      if (textStatus !== "abort") {
        $form.removeData('pendingRequest');
        $spinnerTarget.hideSpinner();
      }
    }));
  };

  $(document).on('change', '[data-behavior-refresh-form]', refreshForm);
  $(document).on('keyup', '[data-behavior-refresh-form]', debounce(refreshForm, 500));
}());
